var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.initial
      ? _c("div", [
          _vm.success
            ? _c(
                "span",
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("account-reenable-success"))
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { attrs: { tag: "a", to: "/inicio-sesion" } },
                    [_vm._v(_vm._s(_vm.$helpers.getV2AppUrl("inicio-sesion")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.error
            ? _c(
                "span",
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("account-reenable-fail")) + " "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { attrs: { to: "/inicio-sesion", tag: "a" } },
                    [_vm._v(_vm._s(_vm.$helpers.getV2AppUrl("inicio-sesion")))]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _c("div", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("resend-account-enable-email-success", {
                  email: _vm.email
                })
              ) +
              "\n  "
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6aee2e82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aee2e82","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/account/ReenableAccount.vue
// module id = 4415
// module chunks = 113